<div class="tw-items-center tw-mb-3">
    <div class="tw-flex-grow tw-me-2 tw-mb-2">
        <h2
            class="tw-mb-3"
            [ngClass]="{ 'tw-text-xs tw-font-semibold': size === 'sm', 'tw-text-base tw-font-bold': size === 'md', 'tw-text-lg tw-font-bold': !size }"
        >
            {{ name }}
        </h2>
    </div>
    <form class="tw-flex tw-gap-2" [formGroup]="form">
        @if (dropdownTypesAvailable) {
            <div class="tw-min-w-[10rem] tw-max-w-[20rem]">
                <app-form-dropdown-single-select
                    elementDataTest="leaderboardTypesDropdown"
                    class="tw-max-w-[20rem]"
                    controlName="type"
                    [label]="dropdownTypes[0].name"
                    [items]="dropdownTypes"
                />
            </div>
        }
        <div class="tw-min-w-[10rem] tw-max-w-[20rem]">
            <app-form-dropdown-single-select
                elementDataTest="leaderboardRangesDropdown"
                class="tw-max-w-[20rem]"
                controlName="range"
                [label]="dropdownRanges[0].name"
                [items]="dropdownRanges"
            />
        </div>
    </form>
</div>

<div *ngIf="loading && !hasUsers" class="tw-py-6">
    <app-loader loaderColor="default" loaderSize="s"></app-loader>
</div>

<div class="tw-relative tw-mt-12">
    <div [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }" (psYReachEnd)="onReachEnd()" class="leaderboard-ps-wrapper">
        <div role="list" class="tw-pr-6 md:tw-pr-4">
            <div role="listitem" *ngFor="let user of leaderboard; let last = last" [class.mb-1]="!last">
                <app-leaderboard-item *ngIf="typeGamification(user)" [user]="user"></app-leaderboard-item>
                <app-leaderboard-item-goal *ngIf="typeGoal(user)" [user]="user"></app-leaderboard-item-goal>
            </div>
        </div>
    </div>
    <div *ngIf="loading && hasUsers" class="cover-loader">
        <app-loader overlayColor="white" loaderSize="s"></app-loader>
    </div>
</div>
